import { useEffect, useState } from "react";

/** Seconds on one question, unanswered and with the page in view, before the nudge shows. */
export const DWELL_SECONDS = 20;

/**
 * True once someone has looked at the same unanswered question for DWELL_SECONDS (Dane and
 * Taylor, Oct 21 call: a prompt to go with their first instinct when they're stuck). Time with
 * the tab hidden doesn't count. It starts again on every question, and never runs while
 * `paused` (answered already, or the first question of a part, whose time includes reading
 * the part's introduction).
 */
export function useDwell(key: string | null, paused: boolean, seconds = DWELL_SECONDS): boolean {
  const [stuck, setStuck] = useState(false);
  useEffect(() => {
    setStuck(false);
    if (key === null || paused) return;
    let shown = 0;
    const tick = setInterval(() => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
      shown += 1;
      if (shown >= seconds) {
        setStuck(true);
        clearInterval(tick);
      }
    }, 1000);
    return () => clearInterval(tick);
  }, [key, paused, seconds]);
  return stuck && !paused;
}
